export const COUNTRIES_DATA = [
  {
    Id: 'AU',
    Name: 'Australia',
  },
  {
    Id: 'CA',
    Name: 'Canada',
  },
  {
    Id: 'FR',
    Name: 'France',
  },
  {
    Id: 'NL',
    Name: 'Netherlands',
  },
  {
    Id: 'NZ',
    Name: 'New Zealand',
  },
  {
    Id: 'GB',
    Name: 'United Kingdom',
  },
  {
    Id: 'US',
    Name: 'United States',
  },
  {
    Id: 'AF',
    Name: 'Afghanistan',
  },
  {
    Id: 'AX',
    Name: 'Aland Islands',
  },
  {
    Id: 'AL',
    Name: 'Albania',
  },
  {
    Id: 'DZ',
    Name: 'Algeria',
  },
  {
    Id: 'AS',
    Name: 'American Samoa',
  },
  {
    Id: 'AD',
    Name: 'Andorra',
  },
  {
    Id: 'AO',
    Name: 'Angola',
  },
  {
    Id: 'AI',
    Name: 'Anguilla',
  },
  {
    Id: 'AQ',
    Name: 'Antarctica',
  },
  {
    Id: 'AG',
    Name: 'Antigua and Barbuda',
  },
  {
    Id: 'AR',
    Name: 'Argentina',
  },
  {
    Id: 'AM',
    Name: 'Armenia',
  },
  {
    Id: 'AW',
    Name: 'Aruba',
  },
  {
    Id: 'AT',
    Name: 'Austria',
  },
  {
    Id: 'AZ',
    Name: 'Azerbaijan',
  },
  {
    Id: 'BS',
    Name: 'Bahamas',
  },
  {
    Id: 'BH',
    Name: 'Bahrain',
  },
  {
    Id: 'BD',
    Name: 'Bangladesh',
  },
  {
    Id: 'BB',
    Name: 'Barbados',
  },
  {
    Id: 'BY',
    Name: 'Belarus',
  },
  {
    Id: 'BE',
    Name: 'Belgium',
  },
  {
    Id: 'BZ',
    Name: 'Belize',
  },
  {
    Id: 'BJ',
    Name: 'Benin',
  },
  {
    Id: 'BM',
    Name: 'Bermuda',
  },
  {
    Id: 'BT',
    Name: 'Bhutan',
  },
  {
    Id: 'BO',
    Name: 'Bolivia',
  },
  {
    Id: 'BA',
    Name: 'Bosnia and Herzegovina',
  },
  {
    Id: 'BW',
    Name: 'Botswana',
  },
  {
    Id: 'BV',
    Name: 'Bouvet Island',
  },
  {
    Id: 'BR',
    Name: 'Brazil',
  },
  {
    Id: 'IO',
    Name: 'British Indian Ocean Territory',
  },
  {
    Id: 'VG',
    Name: 'British Virgin Islands',
  },
  {
    Id: 'BN',
    Name: 'Brunei',
  },
  {
    Id: 'BG',
    Name: 'Bulgaria',
  },
  {
    Id: 'BF',
    Name: 'Burkina Faso',
  },
  {
    Id: 'BI',
    Name: 'Burundi',
  },
  {
    Id: 'KH',
    Name: 'Cambodia',
  },
  {
    Id: 'CM',
    Name: 'Cameroon',
  },
  {
    Id: 'CV',
    Name: 'Cape Verde',
  },
  {
    Id: 'BQ',
    Name: 'Caribbean Netherlands',
  },
  {
    Id: 'KY',
    Name: 'Cayman Islands',
  },
  {
    Id: 'CF',
    Name: 'Central African Republic',
  },
  {
    Id: 'TD',
    Name: 'Chad',
  },
  {
    Id: 'CL',
    Name: 'Chile',
  },
  {
    Id: 'CN',
    Name: 'China',
  },
  {
    Id: 'CX',
    Name: 'Christmas Island',
  },
  {
    Id: 'CC',
    Name: 'Cocos (Keeling) Islands',
  },
  {
    Id: 'CO',
    Name: 'Colombia',
  },
  {
    Id: 'KM',
    Name: 'Comoros',
  },
  {
    Id: 'CG',
    Name: 'Congo (Brazzaville)',
  },
  {
    Id: 'CD',
    Name: 'Congo (Kinshasa)',
  },
  {
    Id: 'CK',
    Name: 'Cook Islands',
  },
  {
    Id: 'CR',
    Name: 'Costa Rica',
  },
  {
    Id: 'HR',
    Name: 'Croatia',
  },
  {
    Id: 'CU',
    Name: 'Cuba',
  },
  {
    Id: 'CW',
    Name: 'Curaçao',
  },
  {
    Id: 'CY',
    Name: 'Cyprus',
  },
  {
    Id: 'CZ',
    Name: 'Czech Republic',
  },
  {
    Id: 'DK',
    Name: 'Denmark',
  },
  {
    Id: 'DJ',
    Name: 'Djibouti',
  },
  {
    Id: 'DM',
    Name: 'Dominica',
  },
  {
    Id: 'DO',
    Name: 'Dominican Republic',
  },
  {
    Id: 'EC',
    Name: 'Ecuador',
  },
  {
    Id: 'EG',
    Name: 'Egypt',
  },
  {
    Id: 'SV',
    Name: 'El Salvador',
  },
  {
    Id: 'GQ',
    Name: 'Equatorial Guinea',
  },
  {
    Id: 'ER',
    Name: 'Eritrea',
  },
  {
    Id: 'EE',
    Name: 'Estonia',
  },
  {
    Id: 'ET',
    Name: 'Ethiopia',
  },
  {
    Id: 'FK',
    Name: 'Falkland Islands',
  },
  {
    Id: 'FO',
    Name: 'Faroe Islands',
  },
  {
    Id: 'FJ',
    Name: 'Fiji',
  },
  {
    Id: 'FI',
    Name: 'Finland',
  },
  {
    Id: 'GF',
    Name: 'French Guiana',
  },
  {
    Id: 'PF',
    Name: 'French Polynesia',
  },
  {
    Id: 'TF',
    Name: 'French Southern Territories',
  },
  {
    Id: 'GA',
    Name: 'Gabon',
  },
  {
    Id: 'GM',
    Name: 'Gambia',
  },
  {
    Id: 'GE',
    Name: 'Georgia',
  },
  {
    Id: 'DE',
    Name: 'Germany',
  },
  {
    Id: 'GH',
    Name: 'Ghana',
  },
  {
    Id: 'GI',
    Name: 'Gibraltar',
  },
  {
    Id: 'GR',
    Name: 'Greece',
  },
  {
    Id: 'GL',
    Name: 'Greenland',
  },
  {
    Id: 'GD',
    Name: 'Grenada',
  },
  {
    Id: 'GP',
    Name: 'Guadeloupe',
  },
  {
    Id: 'GU',
    Name: 'Guam',
  },
  {
    Id: 'GT',
    Name: 'Guatemala',
  },
  {
    Id: 'GG',
    Name: 'Guernsey',
  },
  {
    Id: 'GN',
    Name: 'Guinea',
  },
  {
    Id: 'GW',
    Name: 'Guinea-Bissau',
  },
  {
    Id: 'GY',
    Name: 'Guyana',
  },
  {
    Id: 'HT',
    Name: 'Haiti',
  },
  {
    Id: 'HM',
    Name: 'Heard Island and McDonald Islands',
  },
  {
    Id: 'HN',
    Name: 'Honduras',
  },
  {
    Id: 'HK',
    Name: 'Hong Kong S.A.R., China',
  },
  {
    Id: 'HU',
    Name: 'Hungary',
  },
  {
    Id: 'IS',
    Name: 'Iceland',
  },
  {
    Id: 'IN',
    Name: 'India',
  },
  {
    Id: 'ID',
    Name: 'Indonesia',
  },
  {
    Id: 'IR',
    Name: 'Iran',
  },
  {
    Id: 'IQ',
    Name: 'Iraq',
  },
  {
    Id: 'IE',
    Name: 'Ireland',
  },
  {
    Id: 'IM',
    Name: 'Isle of Man',
  },
  {
    Id: 'IL',
    Name: 'Israel',
  },
  {
    Id: 'IT',
    Name: 'Italy',
  },
  {
    Id: 'CI',
    Name: 'Ivory Coast',
  },
  {
    Id: 'JM',
    Name: 'Jamaica',
  },
  {
    Id: 'JP',
    Name: 'Japan',
  },
  {
    Id: 'JE',
    Name: 'Jersey',
  },
  {
    Id: 'JO',
    Name: 'Jordan',
  },
  {
    Id: 'KZ',
    Name: 'Kazakhstan',
  },
  {
    Id: 'KE',
    Name: 'Kenya',
  },
  {
    Id: 'KI',
    Name: 'Kiribati',
  },
  {
    Id: 'XK',
    Name: 'Kosovo',
  },
  {
    Id: 'KW',
    Name: 'Kuwait',
  },
  {
    Id: 'KG',
    Name: 'Kyrgyzstan',
  },
  {
    Id: 'LA',
    Name: 'Laos',
  },
  {
    Id: 'LV',
    Name: 'Latvia',
  },
  {
    Id: 'LB',
    Name: 'Lebanon',
  },
  {
    Id: 'LS',
    Name: 'Lesotho',
  },
  {
    Id: 'LR',
    Name: 'Liberia',
  },
  {
    Id: 'LY',
    Name: 'Libya',
  },
  {
    Id: 'LI',
    Name: 'Liechtenstein',
  },
  {
    Id: 'LT',
    Name: 'Lithuania',
  },
  {
    Id: 'LU',
    Name: 'Luxembourg',
  },
  {
    Id: 'MO',
    Name: 'Macao S.A.R., China',
  },
  {
    Id: 'MK',
    Name: 'Macedonia',
  },
  {
    Id: 'MG',
    Name: 'Madagascar',
  },
  {
    Id: 'MW',
    Name: 'Malawi',
  },
  {
    Id: 'MY',
    Name: 'Malaysia',
  },
  {
    Id: 'MV',
    Name: 'Maldives',
  },
  {
    Id: 'ML',
    Name: 'Mali',
  },
  {
    Id: 'MT',
    Name: 'Malta',
  },
  {
    Id: 'MH',
    Name: 'Marshall Islands',
  },
  {
    Id: 'MQ',
    Name: 'Martinique',
  },
  {
    Id: 'MR',
    Name: 'Mauritania',
  },
  {
    Id: 'MU',
    Name: 'Mauritius',
  },
  {
    Id: 'YT',
    Name: 'Mayotte',
  },
  {
    Id: 'MX',
    Name: 'Mexico',
  },
  {
    Id: 'FM',
    Name: 'Micronesia',
  },
  {
    Id: 'MD',
    Name: 'Moldova',
  },
  {
    Id: 'MC',
    Name: 'Monaco',
  },
  {
    Id: 'MN',
    Name: 'Mongolia',
  },
  {
    Id: 'ME',
    Name: 'Montenegro',
  },
  {
    Id: 'MS',
    Name: 'Montserrat',
  },
  {
    Id: 'MA',
    Name: 'Morocco',
  },
  {
    Id: 'MZ',
    Name: 'Mozambique',
  },
  {
    Id: 'MM',
    Name: 'Myanmar',
  },
  {
    Id: 'NA',
    Name: 'Namibia',
  },
  {
    Id: 'NR',
    Name: 'Nauru',
  },
  {
    Id: 'NP',
    Name: 'Nepal',
  },
  {
    Id: 'AN',
    Name: 'Netherlands Antilles',
  },
  {
    Id: 'NC',
    Name: 'New Caledonia',
  },
  {
    Id: 'NI',
    Name: 'Nicaragua',
  },
  {
    Id: 'NE',
    Name: 'Niger',
  },
  {
    Id: 'NG',
    Name: 'Nigeria',
  },
  {
    Id: 'NU',
    Name: 'Niue',
  },
  {
    Id: 'NF',
    Name: 'Norfolk Island',
  },
  {
    Id: 'MP',
    Name: 'Northern Mariana Islands',
  },
  {
    Id: 'KP',
    Name: 'North Korea',
  },
  {
    Id: 'NO',
    Name: 'Norway',
  },
  {
    Id: 'OM',
    Name: 'Oman',
  },
  {
    Id: 'PK',
    Name: 'Pakistan',
  },
  {
    Id: 'PW',
    Name: 'Palau',
  },
  {
    Id: 'PS',
    Name: 'Palestinian Territory',
  },
  {
    Id: 'PA',
    Name: 'Panama',
  },
  {
    Id: 'PG',
    Name: 'Papua New Guinea',
  },
  {
    Id: 'PY',
    Name: 'Paraguay',
  },
  {
    Id: 'PE',
    Name: 'Peru',
  },
  {
    Id: 'PH',
    Name: 'Philippines',
  },
  {
    Id: 'PN',
    Name: 'Pitcairn',
  },
  {
    Id: 'PL',
    Name: 'Poland',
  },
  {
    Id: 'PT',
    Name: 'Portugal',
  },
  {
    Id: 'PR',
    Name: 'Puerto Rico',
  },
  {
    Id: 'QA',
    Name: 'Qatar',
  },
  {
    Id: 'RE',
    Name: 'Reunion',
  },
  {
    Id: 'RO',
    Name: 'Romania',
  },
  {
    Id: 'RU',
    Name: 'Russia',
  },
  {
    Id: 'RW',
    Name: 'Rwanda',
  },
  {
    Id: 'BL',
    Name: 'Saint Barthélemy',
  },
  {
    Id: 'SH',
    Name: 'Saint Helena',
  },
  {
    Id: 'KN',
    Name: 'Saint Kitts and Nevis',
  },
  {
    Id: 'LC',
    Name: 'Saint Lucia',
  },
  {
    Id: 'MF',
    Name: 'Saint Martin (French part)',
  },
  {
    Id: 'PM',
    Name: 'Saint Pierre and Miquelon',
  },
  {
    Id: 'VC',
    Name: 'Saint Vincent and the Grenadines',
  },
  {
    Id: 'WS',
    Name: 'Samoa',
  },
  {
    Id: 'SM',
    Name: 'San Marino',
  },
  {
    Id: 'ST',
    Name: 'Sao Tome and Principe',
  },
  {
    Id: 'SA',
    Name: 'Saudi Arabia',
  },
  {
    Id: 'SN',
    Name: 'Senegal',
  },
  {
    Id: 'RS',
    Name: 'Serbia',
  },
  {
    Id: 'SC',
    Name: 'Seychelles',
  },
  {
    Id: 'SL',
    Name: 'Sierra Leone',
  },
  {
    Id: 'SG',
    Name: 'Singapore',
  },
  {
    Id: 'SX',
    Name: 'Sint Maarten',
  },
  {
    Id: 'SK',
    Name: 'Slovakia',
  },
  {
    Id: 'SI',
    Name: 'Slovenia',
  },
  {
    Id: 'SB',
    Name: 'Solomon Islands',
  },
  {
    Id: 'SO',
    Name: 'Somalia',
  },
  {
    Id: 'ZA',
    Name: 'South Africa',
  },
  {
    Id: 'GS',
    Name: 'South Georgia and the South Sandwich Islands',
  },
  {
    Id: 'KR',
    Name: 'South Korea',
  },
  {
    Id: 'SS',
    Name: 'South Sudan',
  },
  {
    Id: 'ES',
    Name: 'Spain',
  },
  {
    Id: 'LK',
    Name: 'Sri Lanka',
  },
  {
    Id: 'SD',
    Name: 'Sudan',
  },
  {
    Id: 'SR',
    Name: 'Suriname',
  },
  {
    Id: 'SJ',
    Name: 'Svalbard and Jan Mayen',
  },
  {
    Id: 'SZ',
    Name: 'Swaziland',
  },
  {
    Id: 'SE',
    Name: 'Sweden',
  },
  {
    Id: 'CH',
    Name: 'Switzerland',
  },
  {
    Id: 'SY',
    Name: 'Syria',
  },
  {
    Id: 'TW',
    Name: 'Taiwan',
  },
  {
    Id: 'TJ',
    Name: 'Tajikistan',
  },
  {
    Id: 'TZ',
    Name: 'Tanzania',
  },
  {
    Id: 'TH',
    Name: 'Thailand',
  },
  {
    Id: 'TL',
    Name: 'Timor-Leste',
  },
  {
    Id: 'TG',
    Name: 'Togo',
  },
  {
    Id: 'TK',
    Name: 'Tokelau',
  },
  {
    Id: 'TO',
    Name: 'Tonga',
  },
  {
    Id: 'TT',
    Name: 'Trinidad and Tobago',
  },
  {
    Id: 'TN',
    Name: 'Tunisia',
  },
  {
    Id: 'TR',
    Name: 'Turkey',
  },
  {
    Id: 'TM',
    Name: 'Turkmenistan',
  },
  {
    Id: 'TC',
    Name: 'Turks and Caicos Islands',
  },
  {
    Id: 'TV',
    Name: 'Tuvalu',
  },
  {
    Id: 'VI',
    Name: 'U.S. Virgin Islands',
  },
  {
    Id: 'UG',
    Name: 'Uganda',
  },
  {
    Id: 'UA',
    Name: 'Ukraine',
  },
  {
    Id: 'AE',
    Name: 'United Arab Emirates',
  },
  {
    Id: 'UM',
    Name: 'United States Minor Outlying Islands',
  },
  {
    Id: 'UY',
    Name: 'Uruguay',
  },
  {
    Id: 'UZ',
    Name: 'Uzbekistan',
  },
  {
    Id: 'VU',
    Name: 'Vanuatu',
  },
  {
    Id: 'VA',
    Name: 'Vatican',
  },
  {
    Id: 'VE',
    Name: 'Venezuela',
  },
  {
    Id: 'VN',
    Name: 'Vietnam',
  },
  {
    Id: 'WF',
    Name: 'Wallis and Futuna',
  },
  {
    Id: 'EH',
    Name: 'Western Sahara',
  },
  {
    Id: 'YE',
    Name: 'Yemen',
  },
  {
    Id: 'ZM',
    Name: 'Zambia',
  },
  {
    Id: 'ZW',
    Name: 'Zimbabwe',
  },
];
